import * as React from "react";
import { IFSecure, IServiceStatus } from "@nju/data-access-portal-product";
import { Button } from "@nju/ui";
import { FSecureReactivationButton } from "./FSecureReactivationButton";
import { IServiceCTABannerConditions } from "./types";

interface IButtonsProps {
  subscribeCallback: (
    status?: IServiceStatus["fSecureServiceStatus"] | "AlmostTerminated",
  ) => void;
  refreshCallback: () => void;
  conditions: IServiceCTABannerConditions;
  fSecureServiceStatus: IServiceStatus["fSecureServiceStatus"];
  access: IFSecure | undefined;
}

export function Buttons({
  conditions,
  fSecureServiceStatus,
  subscribeCallback,
  access,
  refreshCallback,
}: IButtonsProps) {
  const { isPendingTermination, isSuspended, isPendingReactivation } =
    conditions;

  if (isPendingTermination) {
    return (
      <Button
        onPress={() => {
          return subscribeCallback(fSecureServiceStatus);
        }}
        size={{
          "@onlyMobile": "s",
          "@fromTablet": "m",
        }}
      >
        anuluj rezygnację z usługi
      </Button>
    );
  }

  if (isSuspended && (access?.terminationDate || access?.statusChangeDate)) {
    return <FSecureReactivationButton />;
  }

  if (isPendingReactivation) {
    return (
      <Button
        onPress={() => {
          return refreshCallback();
        }}
        size={{
          "@onlyMobile": "s",
          "@fromTablet": "m",
        }}
      >
        odśwież
      </Button>
    );
  }

  // eslint-disable-next-line unicorn/no-null
  return null;
}
